import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import RestaurantRow from './restaurantRow'
import { removeFromPool, addToPool } from '../../../../actions/poolRestaurants'
import { bindActionCreators } from 'redux'

export class RestaurantTable extends React.Component {
  render() {
    let body = this.props.restaurants.map(r => (<RestaurantRow poolSubscriptionName={this.props.poolSubscriptionName} restaurant={r} restaurantDisplayAction={this.props.restaurantDisplayAction} key={r.id} addToPool={this.props.addToPool} removeFromPool={this.props.removeFromPool} />))

    return (
      <React.Fragment>
        <table className="table table-striped">
          <thead>
            <tr className="codebox-title">
              <th>ID #</th>
              <th>Restaurant Name</th>
              <th>Subscriptions</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {body}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  removeFromPool,
  addToPool
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(RestaurantTable)

RestaurantTable.propTypes = {
  poolSubscriptionName: PropTypes.string,
  restaurantDisplayAction: PropTypes.symbol.isRequired,
  restaurants: PropTypes.array.isRequired,
  addToPool: PropTypes.func,
  removeFromPool: PropTypes.func
}

RestaurantTable.defaultProps = {
  addToPool: () => {},
  removeFromPool: () => {}
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/restaurants/restaurantTable.js